export default "__VITE_ASSET__B96j7sSJ__ 584w";